export enum ALIGNMENT {
  LEFT = 'left',
  RIGHT = 'right',
  UP = 'up',
  DOWN = 'down',
}

export enum BASIC_SELECT_SIZES {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export const OVERSCAN_COUNT = 3;

export const DEFAULT_CATEGORY_ID = 'default';
// used when categorizing selected options
export const SELECTED_OPTIONS_CATEGORY_ID = 'selected-options-default';
